var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['btn-follow', { followed: _vm.isFollow(_vm.id) || _vm.followed }],on:{"click":function($event){$event.stopPropagation();return _vm.onClick.apply(null, arguments)}}},[(!_vm.id && !_vm.text && _vm.isArrow)?_c('span',[_vm._v("+")]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.text ||
    _vm.$t(
      _vm.isFollow(_vm.id) || _vm.followed
        ? 'btn-follow.followed'
        : 'btn-follow.not-follow'
    ))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }